"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySystem = exports.DRMType = void 0;
exports.DRMType = {
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "com.widevine.alpha",
    FAIRPLAY: "com.apple.fps",
};
exports.KeySystem = {
    FAIRPLAY: "com.apple.fps.1_0",
    WIDEVINE: "com.widevine.alpha",
    PLAYREADY: "com.microsoft.playready",
    PLAYREADY_CHROMECAST: "com.chromecast.playready",
};
//# sourceMappingURL=common.js.map